import Fuse from 'fuse.js'

export default {
  computed: {

    queriedData() {
      let result = this.claims;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = []
        }
      }
      return result;
    },
    to() {
      // let highBound = this.from + this.pagination.rowsPerPage;
      // if (this.total < highBound) {
      //   highBound = this.total;
      // }
      // return highBound;
      return this.pagination.to;
    },
    from() {
      // return this.pagination.rowsPerPage * (this.pagination.page - 1);
      return this.pagination.from;
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.totalItems;
    }
  },
  data() {
    return {
      // pagination: {
      //   perPage: 10,
      //   currentPage: 1,
      //   perPageOptions: [5, 10, 25, 50],
      //   total: 0
      // },
      searchQuery: '',
      searchedData: [],
      fuseSearch: null,
    }
  },
  methods: {
    sortChange({prop, order}) {
      if (prop) {
        this.claims.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.claims.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
    next(page) {
      this.pageActual = page;
      this.SET_CLAIMS([]);
      this.SET_PAGINATION({})
    }
  },
  mounted() {
    // Fuse search initialization.
    this.GET_CLAIMS({page: 1})
      .then(() => {
        // this.tableData = this.orders
        this.pageActual = this.pagination.page;
        this.fuseSearch = new Fuse(this.claims, {
          keys: ['nivel', 'detalle'],
          threshold: 0.3
        });
      });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.claims;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    pageActual(value) {
      this.GET_CLAIMS({page: value})
        .then(() => {
          // this.tableData = this.orders
          // this.pageActual = this.pagination.page;
          this.fuseSearch = new Fuse(this.claims, {
            keys: ['nivel', 'detalle'],
            threshold: 0.3
          });
        });
    }
  }
}
